import { string } from 'prop-types';
import React from 'react';

import SvgIcon from 'ravenjs/lib/SvgIcon';

import { MIGRATED_COLORS } from 'constants/quartz/migrated_colors';

const BoltIcon = ({ fill, height, viewBox, width, ...rest }) => (
    <SvgIcon height={height} viewBox={viewBox} width={width} {...rest}>
        <path
            d="M9.6 0 1.8 9.25h5.45L5.8 16 14.2 6.4H8.75L9.6 0Z"
            fill={fill}
            fillRule="evenodd"
            clipRule="evenodd"
        />
    </SvgIcon>
);

BoltIcon.propTypes = {
    fill: string,
    height: string,
    viewBox: string,
    width: string,
};

BoltIcon.defaultProps = {
    fill: MIGRATED_COLORS.grey27,
    height: '16',
    viewBox: '0 0 16 16',
    width: '16',
};

export default BoltIcon;
